import type { ICatalogInstallConfig } from "./HubCatalogInstall.types";

export enum HubPackageDeploymentStatus {
  PENDING = "pending",
  INSTALLED = "installed",
  FAILED = "failed",
}

export interface IHubPackageDeploymentCatalog {
  catalogId: number;
  catalogVersion: number;
}
export interface IHubPackageDeployment {
  deploymentId?: number;
  packageId: number;
  companyId: number;
  tenantKey?: string;
  tenantName: string;
  applicationId: string;
  targetSolutionId?: string;
  replaceTargetEntity?: boolean;
  config?: ICatalogInstallConfig[];
  status: HubPackageDeploymentStatus | string;
  installedBy?: string;
  installedDatetime?: string;
  installedCatalogs: IHubPackageDeploymentCatalog[];
  name: string;
  description?: string;
  targetSolutionName?: string;
  targetSolutionLabel?: string;
}
